import React, { useRef, useState } from 'react'
import { View, TouchableOpacity, Dimensions, Image } from 'react-native'
import PropTypes from 'prop-types'
import { RNCamera } from 'react-native-infy-camera'
import { RNHoleView } from 'react-native-hole-view'
// import ImageEditor from '@react-native-community/image-editor'

import RNFS from 'react-native-fs'

import { VFText, VFButton, Icon } from '@vfgroup-oneplatform/foundation/Components'

import { Images } from '../../Themes'

import styles from './CameraStep.Styles'


const { width: SCREEN_WIDTH } = Dimensions.get('screen')


const cameraSteps = {
  first: 'first',
  second: 'second',
  third: 'third',
}


const FirstStep = ({
  setActiveIndex,
  toggleCameraModal,
  frontIdPhoto,
  setFrontIdPhoto,
  setFrontIdPhotoBase64
}) => {

  const cameraRef = useRef()

  const [flashState, setFlashState] = useState(RNCamera.Constants.FlashMode.off)


  const width = SCREEN_WIDTH - 64
  const cameraHeight = SCREEN_WIDTH * 16 / 9

  const imageHeight = width / 1.582

  const topVerticalOffset = (cameraHeight - 120 - imageHeight) / 2

  const toggleFlash = () => {
    if (flashState === RNCamera.Constants.FlashMode.off) {
      setFlashState(RNCamera.Constants.FlashMode.torch)
    } else {
      setFlashState(RNCamera.Constants.FlashMode.off)
    }
  }

  const takePicture = async () => {
    try {
      if (cameraRef.current) {
        const options = {
          width: SCREEN_WIDTH,
          quality: 1,
          base64: true,
          skipProcessing: true,
          fixOrientation: true,
          forceUpOrientation: true,
          pauseAfterCapture: true,
          orientation: 'portrait',
        }

        const data = await cameraRef.current.takePictureAsync(options)

        const cropData = {
          offset: { x: 32, y: topVerticalOffset },
          size: { width: width, height: imageHeight },
          resizeMode: 'contain',
        }

        // const cropedImage = await ImageEditor.cropImage(data.uri, cropData)

        setFrontIdPhoto(cropedImage)

        RNFS.readFile(cropedImage, 'base64').then(res => setFrontIdPhotoBase64(res))

      }

    } catch (error) {
      console.log(error)
    }

  }

  const retakePhoto = () => {
    setFrontIdPhoto()
  }

  const continueToNextStep = () => {
    setActiveIndex(cameraSteps.second)
  }


  return (
    <>
      {frontIdPhoto ? <View style={styles.showImageContainer}>

        <View style={styles.headerContainer}>
          <View style={styles.emptyIcon} />

          <TouchableOpacity
            onPress={() => {
              retakePhoto()
              toggleCameraModal()
            }}
          >
            <Icon
              name={Images.close_white}
              size={25}
              resizeMode="contain"
              type="image"
            />
          </TouchableOpacity>
        </View>

        <View style={styles.borderRadius(width, imageHeight, topVerticalOffset)}>
          <Image
            source={{ uri: frontIdPhoto }}
            style={styles.image(width)}
            resizeMode="contain"
          />
        </View>

        <View style={styles.buttonsContainer}>
          <VFButton
            title="acquisition_camera_continue"
            style={styles.button}
            onPress={continueToNextStep}
          />
          <VFButton
            title="acquisition_camera_retake_photo"
            style={styles.button}
            type="secondary"
            onPress={retakePhoto}
          />
        </View>
      </View> :
        <View style={styles.container}>
          <RNCamera
            ref={cameraRef}
            type={RNCamera.Constants.Type.back}
            flashMode={flashState}
            focusable
            useNativeZoom={false}
            zoom={0}
            ratio="16:9"
            style={{ height: cameraHeight, width: SCREEN_WIDTH }}
          >
            <View style={styles.cameraContainer}>

              <RNHoleView
                style={styles.overlayMask}
                holes={[
                  {
                    x: 32,
                    y: topVerticalOffset,
                    width: width,
                    height: imageHeight,
                    borderRadius: 8,
                  },
                ]}
              />
              <View style={styles.borderRadius(width, imageHeight, topVerticalOffset)} />


              <View style={styles.headerContainer}>

                <TouchableOpacity onPress={toggleFlash}>
                  <Icon
                    name={RNCamera.Constants.FlashMode.torch === flashState ? Images.flash_filled : Images.flash}
                    size={25}
                    resizeMode="contain"
                    type="image"
                  />
                </TouchableOpacity>

                <TouchableOpacity onPress={toggleCameraModal}>
                  <Icon
                    name={Images.close_white}
                    size={25}
                    resizeMode="contain"
                    type="image"
                  />
                </TouchableOpacity>

              </View>


              <View style={styles.textContainer}>
                <VFText
                  i18nKey="acquisition_camera_front_id"
                  style={styles.text}
                />
              </View>
            </View>
          </RNCamera>

          <View style={styles.buttonContainer}>
            <TouchableOpacity
              onPress={takePicture}
              style={styles.cameraButtonOutter}>
              <View style={styles.cameraButtonInner} />
            </TouchableOpacity>
          </View>


        </View>}
    </>
  )
}
FirstStep.propTypes = {
  setActiveIndex: PropTypes.func,
  toggleCameraModal: PropTypes.func,
  frontIdPhoto: PropTypes.string,
  setFrontIdPhoto: PropTypes.func,
  setFrontIdPhotoBase64: PropTypes.func,
}


const SecondStep = ({
  setActiveIndex,
  toggleCameraModal,
  backIdPhoto,
  setBackIdPhoto,
  setBackIdPhotoBase64,
}) => {
  const cameraRef = useRef()

  const [flashState, setFlashState] = useState(RNCamera.Constants.FlashMode.off)


  const width = SCREEN_WIDTH - 64
  const cameraHeight = SCREEN_WIDTH * 16 / 9

  const imageHeight = width / 1.582

  const topVerticalOffset = (cameraHeight - 120 - imageHeight) / 2


  const toggleFlash = () => {
    if (flashState === RNCamera.Constants.FlashMode.off) {
      setFlashState(RNCamera.Constants.FlashMode.torch)
    } else {
      setFlashState(RNCamera.Constants.FlashMode.off)
    }
  }

  const takePicture = async () => {
    if (cameraRef.current) {
      const options = {
        width: SCREEN_WIDTH,
        quality: 1,
        base64: true,
        skipProcessing: true,
        fixOrientation: true,
        forceUpOrientation: true,
        pauseAfterCapture: true,
        orientation: 'portrait',
      }

      const cropData = {
        offset: { x: 32, y: topVerticalOffset },
        size: { width: width, height: imageHeight },
        resizeMode: 'contain',
      }

      const data = await cameraRef.current.takePictureAsync(options)

      // const cropedImage = await ImageEditor.cropImage(data.uri, cropData)

      setBackIdPhoto(cropedImage)

      RNFS.readFile(cropedImage, 'base64').then(res => setBackIdPhotoBase64(res))

    }
  }

  const retakePhoto = () => {
    setBackIdPhoto()
  }

  const continueToNextStep = () => {
    setActiveIndex(cameraSteps.third)
  }


  return (
    <>
      {backIdPhoto ? <View style={styles.showImageContainer}>
        <View style={styles.headerContainer}>
          <View style={styles.emptyIcon} />
          <TouchableOpacity
            onPress={() => {
              retakePhoto()
              toggleCameraModal()
            }}
          >
            <Icon
              name={Images.close_white}
              size={25}
              resizeMode="contain"
              type="image"
            />
          </TouchableOpacity>
        </View>

        <View style={styles.borderRadius(width, imageHeight, topVerticalOffset)}>
          <Image
            source={{ uri: backIdPhoto }}
            style={styles.image(width)}
            resizeMode="contain"
          />
        </View>

        <View style={styles.buttonsContainer}>
          <VFButton
            title="acquisition_camera_continue"
            style={styles.button}
            onPress={continueToNextStep}
          />
          <VFButton
            title="acquisition_camera_retake_photo"
            style={styles.button}
            type="secondary"
            onPress={retakePhoto}
          />
        </View>
      </View> :
        <View style={styles.container}>
          <RNCamera
            ref={cameraRef}
            type={RNCamera.Constants.Type.back}
            flashMode={flashState}
            focusable
            useNativeZoom={false}
            zoom={0}
            ratio="16:9"
            style={{ height: cameraHeight, width: SCREEN_WIDTH }}
          >
            <View style={styles.cameraContainer}>

              <RNHoleView
                style={styles.overlayMask}
                holes={[
                  {
                    x: 32,
                    y: topVerticalOffset,
                    width: width,
                    height: imageHeight,
                    borderRadius: 8,
                  },
                ]}
              />

              <View style={styles.borderRadius(width, imageHeight, topVerticalOffset)} />


              <View style={styles.headerContainer}>

                <TouchableOpacity onPress={toggleFlash}>
                  <Icon
                    name={RNCamera.Constants.FlashMode.torch === flashState ? Images.flash_filled : Images.flash}
                    size={25}
                    resizeMode="contain"
                    type="image"
                  />
                </TouchableOpacity>

                <TouchableOpacity onPress={toggleCameraModal}>
                  <Icon
                    name={Images.close_white}
                    size={25}
                    resizeMode="contain"
                    type="image"
                  />
                </TouchableOpacity>

              </View>


              <View style={styles.textContainer}>
                <VFText
                  i18nKey="acquisition_camera_back_id"
                  style={styles.text}
                />
              </View>
            </View>
          </RNCamera>

          <View style={styles.buttonContainer}>
            <TouchableOpacity
              onPress={takePicture}
              style={styles.cameraButtonOutter}>
              <View style={styles.cameraButtonInner} />
            </TouchableOpacity>
          </View>

        </View>}
    </>
  )
}

SecondStep.propTypes = {
  setActiveIndex: PropTypes.func,
  toggleCameraModal: PropTypes.func,
  backIdPhoto: PropTypes.string,
  setBackIdPhoto: PropTypes.func,
  setBackIdPhotoBase64: PropTypes.func,
}


const ThirdStep = ({
  toggleCameraModal,
  selfie,
  setSelfie,
  setSelfieBase64,
}) => {

  const cameraRef = useRef()

  const width = SCREEN_WIDTH - 96
  const cameraHeight = SCREEN_WIDTH * 16 / 9

  const imageHeight = width * 1.582

  const topVerticalOffset = (cameraHeight - 120 - imageHeight) / 2



  const takePicture = async () => {
    if (cameraRef.current) {
      const options = {
        width: SCREEN_WIDTH,
        quality: 1,
        base64: true,
        skipProcessing: true,
        fixOrientation: true,
        forceUpOrientation: true,
        pauseAfterCapture: true,
        orientation: 'portrait',
        mirrorImage: true,
      }

      const cropData = {
        offset: { x: 48, y: topVerticalOffset },
        size: { width: width, height: imageHeight },
        resizeMode: 'contain',
      }

      const data = await cameraRef.current.takePictureAsync(options)

      // const cropedImage = await ImageEditor.cropImage(data.uri, cropData)

      setSelfie(cropedImage)

      RNFS.readFile(cropedImage, 'base64').then(res => setSelfieBase64(res))

    }
  }

  const retakePhoto = () => {
    setSelfie()
  }

  const continueToNextStep = () => {
    toggleCameraModal()
  }


  return (
    <>
      {selfie ? <View style={styles.showImageContainer}>
        <View style={styles.headerContainer}>
          <View style={styles.emptyIcon} />

          <TouchableOpacity
            onPress={() => {
              retakePhoto()
              toggleCameraModal()
            }}
          >
            <Icon
              name={Images.close_white}
              size={25}
              resizeMode="contain"
              type="image"
            />
          </TouchableOpacity>
        </View>

        <View style={styles.borderRadiusThirdStep(width, imageHeight, topVerticalOffset)}>
          <Image
            source={{ uri: selfie }}
            style={styles.image(width)}
            resizeMode="cover"
          />
        </View>

        <View style={styles.buttonsContainer}>
          <VFButton
            title="acquisition_camera_continue"
            style={styles.button}
            onPress={continueToNextStep}
          />
          <VFButton
            title="acquisition_camera_retake_photo"
            style={styles.button}
            type="secondary"
            onPress={retakePhoto}
          />
        </View>
      </View> :
        <View style={styles.container}>
          <RNCamera
            ref={cameraRef}
            type={RNCamera.Constants.Type.front}
            focusable
            useNativeZoom
            zoom={0}
            ratio="16:9"
            style={{ height: cameraHeight, width: SCREEN_WIDTH }}
          >
            <View style={styles.cameraContainer}>

              <RNHoleView
                style={styles.overlayMask}
                holes={[
                  {
                    x: 48,
                    y: topVerticalOffset,
                    width: width,
                    height: imageHeight,
                    borderRadius: width / 2,
                  },
                ]}
              />

              <View style={styles.borderRadiusThirdStep(width, imageHeight, topVerticalOffset)} />

              <View style={styles.headerContainer}>

                <View style={styles.emptyIcon} />

                <TouchableOpacity onPress={toggleCameraModal}>
                  <Icon
                    name={Images.close_white}
                    size={25}
                    resizeMode="contain"
                    type="image"
                  />
                </TouchableOpacity>

              </View>


              <View style={styles.textContainer}>
                <VFText
                  i18nKey="acquisition_camera_selfie"
                  style={styles.text}
                />
              </View>
            </View>

          </RNCamera>

          <View style={styles.buttonContainer}>
            <TouchableOpacity
              onPress={takePicture}
              style={styles.cameraButtonOutter}>
              <View style={styles.cameraButtonInner} />
            </TouchableOpacity>
          </View>
        </View>}
    </>
  )
}

ThirdStep.propTypes = {
  toggleCameraModal: PropTypes.func,
  selfie: PropTypes.string,
  setSelfie: PropTypes.func,
  setSelfieBase64: PropTypes.func,
}


const steps = {
  first: FirstStep,
  second: SecondStep,
  third: ThirdStep,
}


const CameraStep = ({
  toggleCameraModal,
  frontIdPhoto,
  setFrontIdPhoto,
  backIdPhoto,
  setBackIdPhoto,
  selfie,
  setSelfie,
  setFrontIdPhotoBase64,
  setBackIdPhotoBase64,
  setSelfieBase64,
}) => {

  const [activeIndex, setActiveIndex] = useState(frontIdPhoto ? (backIdPhoto ? cameraSteps.third : cameraSteps.second) : cameraSteps.first)

  const Step = steps[activeIndex]

  return (
    <Step
      setActiveIndex={setActiveIndex}
      toggleCameraModal={toggleCameraModal}
      frontIdPhoto={frontIdPhoto}
      setFrontIdPhoto={setFrontIdPhoto}
      backIdPhoto={backIdPhoto}
      setBackIdPhoto={setBackIdPhoto}
      selfie={selfie}
      setSelfie={setSelfie}
      setFrontIdPhotoBase64={setFrontIdPhotoBase64}
      setBackIdPhotoBase64={setBackIdPhotoBase64}
      setSelfieBase64={setSelfieBase64}
    />
  )
}

CameraStep.propTypes = {
  toggleCameraModal: PropTypes.func,
  frontIdPhoto: PropTypes.string,
  setFrontIdPhoto: PropTypes.func,
  backIdPhoto: PropTypes.string,
  setBackIdPhoto: PropTypes.func,
  selfie: PropTypes.string,
  setSelfie: PropTypes.func,
  setFrontIdPhotoBase64: PropTypes.func,
  setBackIdPhotoBase64: PropTypes.func,
  setSelfieBase64: PropTypes.func,
}

export default CameraStep
